module.exports = __webpack_public_path__ + "static/img/cjkuang.png";